






























import Ypay from '@/assets/ypay.png'
import Ysd from '@/assets/ysd.png'
import Pwa from '@/assets/portal.png'
import WebShop from '@/assets/webshop.png'
import Hipernet from '@/assets/hipernet.png'
import YZeleneStaze from '@/assets/yzelenestaze.png'
import DotsLight from '@/assets/dots_light.png'
import Vue from 'vue'

export default Vue.extend({
  name: 'ApplicationsMenu',
  data: () => ({
    items: [
      {
        text: 'Webshop',
        href: process.env.VUE_APP_MENU_WS,
        icon: WebShop
      },
      {
        text: 'Y. Shopping',
        href: process.env.VUE_APP_MENU_YSD,
        icon: Ysd
      },
      {
        text: 'Yettel app',
        href: process.env.VUE_APP_MENU_YETTEL_APP,
        icon: Pwa
      },
      {
        text: 'Y. Pay',
        href: process.env.VUE_APP_MENU_YPAY,
        icon: Ypay
      },
      {
        text: 'Y. Zelene staze',
        href: process.env.VUE_APP_MENU_ZELENE_STAZE,
        icon: YZeleneStaze
      },
      {
        text: 'Yettel TV',
        href: process.env.VUE_APP_MENU_HIPERNET,
        icon: Hipernet
      }
    ],
    imgDots: DotsLight
  }),
  methods: {
    goToUri (uri: string): void {
      window.location.href = uri
    }
  }
})
